// extracted by mini-css-extract-plugin
module.exports = {"marketSwitcher":"MarketSwitcher_marketSwitcher__ka3hU","flag":"MarketSwitcher_flag__CkP_n","name":"MarketSwitcher_name__esov9"};